import { Badge } from '@shripos/ui';

export const STATE_TONE = {
  online: 'success',
  warning: 'warning',
  error: 'danger',
  offline: 'danger',
  unknown: 'neutral',
};
const STATE_LABEL = { online: 'Ready', warning: 'Warning', error: 'Problem', offline: 'Offline', unknown: 'Unknown' };

export function PrinterStatusBadge({ status }) {
  const s = status?.state ?? 'unknown';
  return (
    <Badge tone={STATE_TONE[s]} className="max-w-full">
      <span className="truncate">{status?.message && s !== 'online' ? status.message : STATE_LABEL[s]}</span>
    </Badge>
  );
}
